import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    Authorization: '6IWTTHsvYTHAraxczmZV8MJNvsRDFhzERr+EJH1zCiT+3loXzz7wX0340EOfGJJ',
    User: 'lab_page'
  },
  mutations: {},
  actions: {},
  getters: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js